import * as yup from 'yup';
import i18n from 'i18next';

const schema = yup.object().shape({
  otp_code: yup.number().required(() => i18n.t('auth.validations.required')),
});

export default schema;
